module.exports = __webpack_public_path__ + "static/img/bj.2c05949.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/relation/bj.png
// module id = 13sw
// module chunks = 0